import {Component, Inject, OnInit} from "@angular/core";
import {FormBuilder, FormGroup} from "@angular/forms";
import {MatDialogRef, MAT_DIALOG_DATA} from "@angular/material/dialog";
import {UserRole} from "src/app/auth/auth.model";
import {i18nService} from "src/app/service-utils/i18n.service";
import {Account, User} from "../../../auth/auth.model";
import {
  confirmPasswordValidator,
  passwordValidator,
  requiredFieldValidator
} from "../../../utils/validation/validators";

@Component({
  selector: 'app-user-admin-dialog',
  templateUrl: './user-admin-dialog.component.html',
  styleUrls: ['./user-admin-dialog.component.scss']
})
export class UserAdminDialogComponent implements OnInit {

  form: FormGroup;
  accounts: Account[];
  UserRole = UserRole;
  passwordError: boolean = false;
  confirmPasswordError: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<UserAdminDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public i18nService: i18nService,
    private formBuilder: FormBuilder
  ) {
  }

  ngOnInit(): void {
    if(this.data?.item.username) {
      this.form = this.formBuilder.group({
        username: [this.data?.item.username, requiredFieldValidator()],
        fullName: [this.data?.item.fullName, requiredFieldValidator()],
        role: [((this.data?.item?.role === this.UserRole.ADMIN) ? this.UserRole.ADMIN : this.UserRole.USER), requiredFieldValidator()],
        password: [null, [passwordValidator]],
        confirmPassword: [null, [passwordValidator]],
      }, {
        validator: confirmPasswordValidator
      });
    } else {
      this.form = this.formBuilder.group({
        username: [this.data?.item.username, requiredFieldValidator()],
        fullName: [this.data?.item.fullName, requiredFieldValidator()],
        role: [((this.data?.item?.role === this.UserRole.ADMIN) ? this.UserRole.ADMIN : this.UserRole.USER), requiredFieldValidator()],
        password: [null, [requiredFieldValidator(), passwordValidator]],
        confirmPassword: [null, [requiredFieldValidator(), passwordValidator]],
      }, {
        validator: confirmPasswordValidator
      });
    }
  }

  discard(): void {
    this.dialogRef.close();
  }

  save(): any {
    event.stopPropagation();

    this.form.get('username').markAsTouched();
    this.form.get('fullName').markAsTouched();
    this.form.get('password').markAsTouched();
    this.form.get('confirmPassword').markAsTouched();

    if(this.form.valid) {
      if(this.data?.item.username && this.form.get("password").value !== null && this.form.get("password").value.trim() === '') {
        this.form.get("password").setValue(null);
      }
      let newUser: User = {
        id: null,
        username: this.form.get("username").value,
        fullName: this.form.get("fullName").value,
        role: this.form.get("role").value,
        password: this.form.get("password").value,
      };
      if (this.data) {
        newUser.id = this.data.item.id;
      }
      this.dialogRef.close({data: newUser});
    }
  }
}
